import { render, staticRenderFns } from "./courseResource.vue?vue&type=template&id=2c48e717&scoped=true&"
import script from "./courseResource.vue?vue&type=script&lang=js&"
export * from "./courseResource.vue?vue&type=script&lang=js&"
import style0 from "./courseResource.vue?vue&type=style&index=0&id=2c48e717&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48e717",
  null
  
)

export default component.exports